import React from 'react';
import { CTAButton } from '../CTAButton';
import { patientCases } from '../../data/content';
export function ProblemSection() {
  return <section className="w-full bg-cream" data-id="element-284" data-mp="n96g1wbzkc9v">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-285" data-mp="8l3b8q9oj6mn">
        <h2 className="text-balance text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl lg:text-[42px]" data-id="element-286" data-mp="8iza2g360lq2">
          Smetti di indovinare.
          <span className="mt-1.5 block text-teal" data-id="element-287" data-mp="3vrm7mksf2ldw">
            Inizia a esercitare con sicurezza clinica.
          </span>
        </h2>

        <p className="mt-6 text-[16px] leading-relaxed text-ink/75 sm:text-lg" data-id="element-288" data-mp="3lrv9m94ndo92">
          Ogni settimana, i medici visitano pazienti i cui sintomi della menopausa non rientrano
          perfettamente in un caso da manuale.
        </p>

        <ul className="mt-6 space-y-3" data-id="element-289" data-mp="1k0i8lv5sw0ia">
          {patientCases.map(item => <li key={item} className="border-l-2 border-plum/25 pl-4 text-[15.5px] leading-relaxed text-ink/70 sm:text-base" data-id="element-290" data-mp="1oy0k9tb7cttz">
              {item}
            </li>)}
        </ul>

        <p className="mt-7 text-[16px] leading-relaxed text-ink/75 sm:text-lg" data-id="element-291" data-mp="1iohtsq4pob2q">
          La scienza esiste. Le evidenze sono disponibili. Ma applicarle durante una giornata
          clinica intensa non è sempre semplice.
        </p>

        <p className="mt-4 text-[16px] font-bold leading-relaxed text-plum-deep sm:text-lg" data-id="element-292" data-mp="14op3gvx3jwva">
          Ed è esattamente per questo che è stato creato il Progetto Clinico della Menopausa™.
        </p>

        <p className="mt-4 text-[16px] leading-relaxed text-ink/75 sm:text-lg" data-id="element-293" data-mp="1dpf021u6lra2">
          Invece di leggere centinaia di pagine provenienti da numerose organizzazioni, segui
          semplicemente un unico percorso clinico chiaro.
        </p>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-294" data-mp="2p38xt2p4sc0z">
          <CTAButton label="Voglio un unico percorso clinico chiaro" sub="Accesso immediato • 19 € con pagamento unico" variant="plum" data-id="element-295" data-mp="2k5zc9y4v4kif" />
        </div>
      </div>
    </section>;
}